'use client';

import { Icon } from '@petsmart-ui/sparky';
import { type KeyboardEvent, type MouseEvent, type PropsWithChildren } from 'react';

function stopHostPropagation(event: MouseEvent | KeyboardEvent) {
    event.stopPropagation();
}

export function StackedDrawerBoundary({ children }: PropsWithChildren) {
    return (
        <div role="presentation" onClick={stopHostPropagation} onKeyDown={stopHostPropagation}>
            {children}
        </div>
    );
}

type StackedDrawerBackButtonProps = {
    className: string;
    testId: string;
    onClick: (event: MouseEvent) => void;
};

export function StackedDrawerBackButton({ className, testId, onClick }: StackedDrawerBackButtonProps) {
    return (
        <button type="button" aria-label="Back" className={className} data-testid={testId} onClick={onClick}>
            <Icon name="chevron-left" size="lg" aria-hidden="true" />
        </button>
    );
}
